import { Component, OnInit, ViewChild } from "@angular/core";
import { Observable, tap, map, of } from "rxjs";
import { Store, Select } from "@ngxs/store";

import { Chart } from "chart.js/auto";

import { LocationsEvents } from "../shared/state/locations_events/locations_events.actions";
import { LocationsEventsState } from "../shared/state/locations_events/locations_events.state";
import { Event } from "../shared/models/event/event.model";
import { OrganizationState } from "../shared/state/organization/organization.state";
import { Organization } from "../shared/models/organization/organization.model";
import { Organization as OrganizationAction } from "../shared/state/organization/organization.actions";

import { PaginatorState } from "primeng/paginator";
import { SortMeta } from "primeng/api";
import { Table, TableLazyLoadEvent } from "primeng/table";

@Component({
	selector: "app-dashboard",
	templateUrl: "./dashboard.component.html",
	styleUrls: ["./dashboard.component.scss"],
	standalone: false,
})
export class DashboardComponent implements OnInit {
	organization: any;

	$locationsEventsTableData: Observable<any>;
	columns: any;

	first: number = 0;
	filter: any;
	rowsPerPageOptions: number[] = [10, 25, 50, 100];

	term: string;
	order: number;

	@ViewChild("table") table: Table;

	// @Select(LocationsEventsState.selectLocationEvents)
	// $locationsEvents: Observable<Event[]>;
	// @Select(LocationsEventsState.filter) $filter: Observable<any>;
	// @Select(LocationsEventsState.loading) $loading: Observable<any>;
	@Select(OrganizationState.getOrganization) $organization: Observable<Organization>;

	$locationsData: Observable<any>;
	$hubsData: Observable<any>;
	$devicesData: Observable<any>;

	constructor(private store: Store) {}

	ngOnInit(): void {
		// this.store.dispatch(
		// 	new LocationsEvents.SetFilter({
		// 		per_page: 10,
		// 		page: 1,
		// 		q: "",
		// 		total: "",
		// 	})
		// );
		// this.store.dispatch(new LocationsEvents.FetchAll());

		// this.$filter.subscribe((data) => {
		// 	if (!data) return;
		// 	this.filter = data;
		// 	this.first = (data.page - 1) * data.per_page;
		// });

		this.columns = [
			{
				field: "location",
				header: "Location",
				order: 0,
			},
			{
				field: "device",
				header: "Device",
				order: 0,
			},
			{
				field: "old_value",
				header: "Old Value",
				order: 0,
			},
			{
				field: "new_value",
				header: "New Value",
				order: 0,
			},
			{
				field: "type",
				header: "Type",
				order: 0,
			},
			{
				field: "created_at",
				header: "Created at date",
				order: 0,
			},
		];

		// this.$locationsEventsTableData = this.$locationsEvents.pipe(
		// 	map((events: Event[]) =>
		// 		!events
		// 			? []
		// 			: events.map((e: Event) => {
		// 					return {
		// 						id: e.location.id,
		// 						location: e.location.name ? e.location.name : e.location.third_party.name,
		// 						device:
		// 							e.device && e.device.name
		// 								? e.device.name
		// 								: e.device && e.device.third_party && e.device.third_party.name
		// 								? e.device.third_party.name
		// 								: "-",
		// 						new_value: e.new_value ?? "-",
		// 						old_value: e.old_value ?? "-",
		// 						type: e.type ? `${e.type.target}_${e.type.event}` : "-",
		// 						created_at: e.created_at ?? "-",
		// 					};
		// 			  })
		// 	)
		// );

		this.$devicesData = this.$organization.pipe(
			map((organization: Organization) => {
				const offlineColorRGB = { r: 255, g: 0, b: 0 };
				const onlineColorRGB = { r: 0, g: 255, b: 0 };

				const offlineColor = `rgb(${offlineColorRGB.r}, ${offlineColorRGB.g}, ${offlineColorRGB.b}`;
				const onlineColor = `rgb(${onlineColorRGB.r}, ${onlineColorRGB.g}, ${onlineColorRGB.b}`;

				const devicesData =
					organization.statistics.devices.total == 0
						? [0, 0]
						: [
								organization.statistics.devices.total - organization.statistics.devices.online,
								organization.statistics.devices.online,
						  ];
				return {
					labels: ["Offline", "Online"],
					datasets: [
						{
							data: devicesData,
							backgroundColor: [offlineColor, onlineColor],
							hoverOffset: 4,
						},
					],
				};
			})
		);

		this.$hubsData = this.$organization.pipe(
			map((organization: Organization) => {
				const offlineColorRGB = { r: 255, g: 0, b: 0 };
				const onlineColorRGB = { r: 0, g: 255, b: 0 };

				const offlineColor = `rgb(${offlineColorRGB.r}, ${offlineColorRGB.g}, ${offlineColorRGB.b}`;
				const onlineColor = `rgb(${onlineColorRGB.r}, ${onlineColorRGB.g}, ${onlineColorRGB.b}`;

				const hubsData =
					organization.statistics.hubs.total == 0
						? [0, 0]
						: [organization.statistics.hubs.total - organization.statistics.hubs.online, organization.statistics.hubs.online];
				return {
					labels: ["Offline", "Online"],
					datasets: [
						{
							data: hubsData,
							backgroundColor: [offlineColor, onlineColor],
							hoverOffset: 4,
						},
					],
				};
			})
		);

		this.$locationsData = this.$organization.pipe(
			map((organization: Organization) => {
				const offlineColorRGB = { r: 255, g: 0, b: 0 };
				const onlineColorRGB = { r: 0, g: 255, b: 0 };

				const offlineColor = `rgb(${offlineColorRGB.r}, ${offlineColorRGB.g}, ${offlineColorRGB.b}`;
				const onlineColor = `rgb(${onlineColorRGB.r}, ${onlineColorRGB.g}, ${onlineColorRGB.b}`;

				const locationsData =
					organization.statistics.locations.total == 0
						? [0, 0]
						: [
								organization.statistics.locations.total - organization.statistics.locations.online,
								organization.statistics.locations.online,
						  ];
				return {
					labels: ["Offline", "Online"],
					datasets: [
						{
							data: locationsData,
							backgroundColor: [offlineColor, onlineColor],
							hoverOffset: 4,
						},
					],
				};
			})
		);

		this.$organization
			.pipe(
				tap((organization: Organization) => {
					this.store.dispatch(new LocationsEvents.FetchAll());
				})
			)
			.subscribe((organization: Organization) => {
				if (!organization) return;
				this.organization = organization;
			});
	}

	onSearchEvent() {
		this.store.dispatch(new LocationsEvents.SetFilter({ ...this.filter, q: this.term }));
		this.store.dispatch(new LocationsEvents.FetchAll());
	}

	onPageChange(event: PaginatorState) {
		console.log(event);
		this.first = event.first as number;
		const page: number = event.page ? event.page + 1 : 1;

		this.store.dispatch(
			new LocationsEvents.SetFilter({
				...this.filter,
				page: page,
				per_page: event.rows,
			})
		);
		this.store.dispatch(new LocationsEvents.FetchAll());
	}

	sortChanged(event: TableLazyLoadEvent) {
		console.log(event);
		let s: any[] = [];

		if (event.multiSortMeta) {
			event.multiSortMeta
				?.filter((field: SortMeta) => field.order != 0)
				.forEach((field: SortMeta) => {
					const order = field.order == -1 ? "asc" : "desc";
					s.push(`${field.field}.${order}`);
				});
		} else {
			const columIndex = this.columns.findIndex((column: any) => (column.field = event.sortField));

			if (columIndex == -1) return;

			if (this.columns[columIndex].order == -1 && event.sortOrder) {
				this.columns[columIndex].order = 0;
				this.table.reset();
			} else {
				this.columns[columIndex].order = event.sortOrder;
			}

			const order = this.columns[columIndex].order == 0 ? "default" : this.columns[columIndex].order == -1 ? "asc" : "desc";
			s.push(`${event.sortField}.${order}`);
		}

		this.store.dispatch(new LocationsEvents.SetFilter({ ...this.filter, s: s }));
		this.store.dispatch(new LocationsEvents.FetchAll());
	}

	reloadLocationsEvents() {
		this.store.dispatch(new LocationsEvents.FetchAll());
	}

	HexToRgb(hex: string) {
		hex = hex.replace("#", "");

		if (hex.length === 3) {
			hex = hex
				.split("")
				.map((c) => c + c)
				.join("");
		}

		const bigint = parseInt(hex, 16);
		const r = (bigint >> 16) & 255;
		const g = (bigint >> 8) & 255;
		const b = bigint & 255;

		return {
			r: r,
			g: g,
			b: b,
		};
	}
}
